import customError from './customError.js';

export default customError('NotImplementedError');
